<template>
  <div>
    <el-upload :class="['file-upload', { readonly }]" :disabled="readonly" :multiple="multiple"
      :file-list="formatFileList" :accept="accept" :action="$apis.common.uploadUrl" :limit="limit"
      :before-upload="beforeUpload" :on-success="onSuccess" :on-exceed="onExceed" :on-remove="onRemove" v-bind="$attrs">
      <el-button type="text" icon="el-icon-plus" v-if="!readonly" size="small">点击上传</el-button>
      <template #file="{ file, index }">
        <div class="file-list-item" v-if="['uploading', 'success', 'ready'].includes(file.status)">
          <i class="el-icon-document"></i>
          <span class="name">{{ file.name }}</span>
          <i class="el-icon-delete close" v-if="file.status === 'success' && !readonly"
            @click="onRemove(file, index)"></i>
          <i class="el-icon-view download"
            v-if="file.status === 'success' && preview && ['jpg', 'png', 'jpeg', 'gif'].includes(getFileType(file.name))"
            @click="onPreview(file)"></i>
          <i class="el-icon-download download" v-if="file.status === 'success' && download"
            @click="onDownload(file)"></i>
          <i class="el-icon-refresh-right download" v-if="file.status === 'success' && update" @click="onUpdate(file, index)"></i>
          <el-progress v-if="file.status === 'uploading'" :stroke-width="4" :percentage="file.percentage" />
        </div>
      </template>
      <template #tip>
        <slot name="tip">
          <div v-if="!readonly" class="el-upload__tip">支持{{ accept }}的文件，单个文件不超过 {{ maxSize }}MB，最多可上传 {{ limit }} 个文件
          </div>
          <div class="no-data" v-else-if="formatFileList.length === 0">
            <span>暂无附件</span>
          </div>
        </slot>
      </template>
    </el-upload>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="dialogVisible2" title="更新附件" width="500">
      <el-form class="global-form" style="padding: 30px 40px 20px 20px;">
        <el-form-item label="当前附件">
          {{ currentFileName }}
        </el-form-item>
        <el-form-item label="附件">
          <file-upload v-model="formData.fileUrl" :multiple="false" :limit="1"></file-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer>
  </div>
</template>

<script>
import { deepClone } from '../utils/utils'

export default {
  name: 'FileUpload',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    update: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      // ,.zip,.rar,.7z,.csv
      default: '.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx,.jpg,.png,.jpeg,.gif'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 10
    },
    maxSize: {
      type: Number,
      default: 50
    },
    download: {
      type: Boolean,
      default: true
    },
    preview: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentImageIndex: 0,
      dialogVisible: false,
      dialogVisible2: false,
      formData: {
        fileId: '', // 附件列表返回的文件id
        fileUrl: [] // 新文件上传后返回的 fileUrl字段
      },
      currentFileName: ''
    }
  },
  computed: {
    formatFileList() {
      return this.value.map(item => {
        return {
          name: item.fileName,
          url: item.filePrefix + item.fileUrl
        }
      })
    },
    imageList() {
      return this.formatFileList.filter(item => {
        return ['jpg', 'png', 'jpeg', 'gif'].includes(this.getFileType(item.name))
      })
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    onRemove(file) {
      const index = this.value.findIndex(item => item.fileName === file.name)
      this.value.splice(index, 1)
    },
    onUpdate(file) {
      const index = this.formatFileList.findIndex(item => item.uid === file.uid)
      const data = this.value[index]
      this.formData.fileId = data.fileId
      this.currentFileName = file.name
      this.formData.fileUrl = []
      this.dialogVisible2 = true
    },
    submit() {
      if (!this.formData.fileUrl.length) {
        this.$message({ type: 'error', message: '请上传文件' })
        return
      }
      const formData = deepClone(this.formData)
      const index = this.value.findIndex(item => item.fileName === this.currentFileName)
      this.$axios.post(this.$apis.common.updateUrl, {
        fileId: formData.fileId,
        fileName: formData.fileUrl[0].fileName,
        fileUrl: formData.fileUrl[0].fileUrl
      }).then(() => {
        this.value.splice(index, 1, formData.fileUrl[0])
        this.dialogVisible2 = false
      })
    },
    onPreview(file) {
      if (['jpg', 'png', 'jpeg', 'gif'].includes(this.getFileType(file.name))) {
        this.currentImageIndex = this.imageList.findIndex(url => url.name === file.name)
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },
    // 下载
    onDownload(file) {
      window.location.href = `${file.url}?download=1`
    },
    onSuccess(res, file, uploadFiles) {
      if (res.code === 200) {
        // 保证没有文件需要处理了在进行双向绑定，否则会造成文件列表紊乱
        if (uploadFiles.every(item => !['ready', 'uploading'].includes(item.status))) {
          uploadFiles.forEach(item => {
            if (item.response) {
              this.value.push(res.data)
            }
          })
        }
      } else {
        const fileIndex = uploadFiles.findIndex(item => item.uid === file.uid)
        uploadFiles.splice(fileIndex, 1)
        this.$message({ type: 'error', message: '上传失败！！！' })
      }
    },
    onExceed(files) {
      this.$message({
        type: 'error',
        message: `本次选择${files.length}个，已超出最大上传个数，请重新选择`
      })
    },
    beforeUpload(file) {
      const fileType = this.getFileType(file.name)
      if (!this.accept.includes(fileType)) {
        this.$message({ type: 'error', message: `${file.name}文件格式错误` })
        return false
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message({ type: 'error', message: `${file.name}超过文件的最大大小` })
        return false
      }
      return true
    },
    getFileType(name) {
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      return suffix.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss">
.file-list-item {
  width: 360px;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 6px;
  background-color: #f3f3f3;
  cursor: default;
  border-radius: 4px;

  &:hover {
    background-color: #e8e8e8;
  }

  .name {
    font-size: 14px;
    flex: 1;
    margin-left: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .el-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    top: initial;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow: hidden;

    ::v-deep {
      .el-progress-bar__outer {
        border-radius: 0;
      }

      .el-progress-bar__inner {
        border-radius: 0;
      }
    }
  }

  .close {
    cursor: pointer;
  }

  .download {
    cursor: pointer;
    margin-left: 8px;
  }
}

.file-upload {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &.readonly {
    ::v-deep {
      .el-upload-list__item:first-child {
        margin: 0;
      }
    }
  }

  ::v-deep {
    .el-upload-list {
      width: 360px;
    }

    .el-upload {
      display: inline-flex;
    }
  }
}

.el-upload__tip {
  margin-top: 0;
  line-height: 1.5;
}

.no-data {
  font-size: 14px;
}
</style>
